// Respiratory subsection form field enum
export enum RespiratoryFormField {
  RESPIRATORY_RESPIRATORY_WNL = 'medicalBackground/respiratory/respiratoryWnl',
  RESPIRATORY_COUGH = 'medicalBackground/respiratory/cough',
  RESPIRATORY_OXYGEN = 'medicalBackground/respiratory/oxygen',
  RESPIRATORY_LUNG_SOUNDS = 'medicalBackground/respiratory/lungSounds',
  RESPIRATORY_SYSTEM_SUMMARY = 'medicalBackground/respiratory/systemSummary'
}
